<template>
  <div class="notification-tabs-parts" :class="{ 'notification-tabs-parts--is-pc': isPc }">
    <ul class="notification-tabs-parts__tabs">
      <li class="notification-tabs-parts__tab">
        <button
          class="notification-tabs-parts__button"
          :class="{ 'notification-tabs-parts__button--selected': selectedTabId === 'news' }"
          @click="handleClick('news')"
        >
          <span class="notification-tabs-parts__button__icon">
            <notification-news-icon />
          </span>
          <span class="notification-tabs-parts__button__label">{{
            $tc('NotificationPage.tabs.news')
          }}</span>
        </button>
      </li>
      <li class="notification-tabs-parts__tab">
        <button
          class="notification-tabs-parts__button"
          :class="{ 'notification-tabs-parts__button--selected': selectedTabId === 'point' }"
          @click="handleClick('point')"
        >
          <span class="notification-tabs-parts__button__icon">
            <notification-point-icon />
          </span>
          <span class="notification-tabs-parts__button__label">{{
            $tc('NotificationPage.tabs.point')
          }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import NotificationNewsIcon from '@/components/NotificationPane/NotificationPane/parts/icons/NotificationNewsIcon.vue'
import NotificationPointIcon from '@/components/NotificationPane/NotificationPane/parts/icons/NotificationPointIcon.vue'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'NotificationTabsParts',
  components: { NotificationPointIcon, NotificationNewsIcon },
  props: {
    selectedTabId: {
      type: String,
      default: 'news',
    },
  },
  setup(props, { emit }) {
    const isPc = DeviceInfo.isForPC()

    /**
     * タブを押下したときの処理
     * @param {string} tabId
     */
    const handleClick = (tabId: string) => {
      emit('onClick', tabId)
    }

    return {
      isPc,
      handleClick,
    }
  },
})
</script>

<style scoped lang="scss">
.notification-tabs-parts {
  &__tabs {
    display: flex;
    width: 100%;
    overflow: hidden;
    border: 1px solid $black10;
    border-radius: 8px;

    .notification-tabs-parts--is-pc & {
      gap: 4px;
      justify-content: center;
      border: none;
      border-radius: 0;
    }
  }

  &__tab {
    width: 50%;

    .notification-tabs-parts--is-pc & {
      width: 140px;
    }
  }

  &__button {
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    color: $black;
    letter-spacing: 0.02em;
    background-color: $white;

    .notification-tabs-parts--is-pc & {
      height: 36px;
      color: $black20;
      background-color: transparent;
      border-radius: 50px;
    }

    &--selected {
      background-color: $green-light;

      .notification-tabs-parts--is-pc & {
        color: $white;
        background-color: $black20;
      }
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
    }
  }
}
</style>
